/**
 * Makes the prev/next arrows on the MAIN product image work on tablet/desktop
 * for the "thumbnail" and "thumbnail_slider" gallery layouts.
 *
 * Dawn's generic slider-component (global.js) drives those arrows via
 * horizontal scrolling, but on tablet/desktop this layout instead shows only
 * the active slide (display: none on the rest) and swaps it by clicking a
 * thumbnail (see media-gallery.js setActiveMedia). Scrolling therefore has
 * nothing to scroll to, so the arrows would otherwise look clickable but do
 * nothing. This script makes the arrows trigger the same thumbnail click
 * that already works, and loops around at the start/end.
 */
(function () {
  function initGallery(gallery) {
    var viewer = gallery.querySelector('[id^="GalleryViewer"]');
    var thumbnailList = gallery.querySelector('[id^="Slider-Thumbnails"]');
    if (!viewer || !thumbnailList) return;

    var buttons = viewer.querySelector('.slider-buttons');
    if (!buttons) return;

    var prevBtn = buttons.querySelector('.slider-button--prev');
    var nextBtn = buttons.querySelector('.slider-button--next');
    var counter = buttons.querySelector('.slider-counter--current');
    if (!prevBtn || !nextBtn) return;

    function items() {
      return Array.prototype.slice.call(thumbnailList.children);
    }

    function activeIndex(list) {
      for (var i = 0; i < list.length; i++) {
        var btn = list[i].querySelector('button');
        if (btn && btn.getAttribute('aria-current') === 'true') return i;
      }
      return 0;
    }

    function goTo(step) {
      var list = items();
      if (list.length < 2) return;
      var index = (activeIndex(list) + step + list.length) % list.length;
      var button = list[index].querySelector('button');
      if (!button) return;
      button.click();
      if (counter) counter.textContent = index + 1;
    }

    prevBtn.addEventListener('click', function (event) {
      event.preventDefault();
      goTo(-1);
    });
    nextBtn.addEventListener('click', function (event) {
      event.preventDefault();
      goTo(1);
    });
  }

  document.querySelectorAll('media-gallery').forEach(initGallery);
})();
